__turbopack_context__.v({
  "column": "table-module-scss-module__VZ0ENa__column",
  "correctionBtn": "table-module-scss-module__VZ0ENa__correctionBtn",
  "date": "table-module-scss-module__VZ0ENa__date",
  "datesCol": "table-module-scss-module__VZ0ENa__datesCol",
  "dealsListTable": "table-module-scss-module__VZ0ENa__dealsListTable",
  "expandCollapseBtn": "table-module-scss-module__VZ0ENa__expandCollapseBtn",
  "icon": "table-module-scss-module__VZ0ENa__icon",
  "link": "table-module-scss-module__VZ0ENa__link",
  "parentCell": "table-module-scss-module__VZ0ENa__parentCell",
  "region": "table-module-scss-module__VZ0ENa__region",
  "regionCol": "table-module-scss-module__VZ0ENa__regionCol",
  "sponsorCol": "table-module-scss-module__VZ0ENa__sponsorCol",
  "tickerCol": "table-module-scss-module__VZ0ENa__tickerCol",
  "tickerLabel": "table-module-scss-module__VZ0ENa__tickerLabel",
  "verified": "table-module-scss-module__VZ0ENa__verified",
});
